"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var CollectionHero = /*#__PURE__*/function () {
  function CollectionHero(component) {
    (0, _classCallCheck2["default"])(this, CollectionHero);
    this.dom = {
      $component: component,
      $catmobile: component.querySelector('.CollectionHero__categories-mobile'),
      $catList: component.querySelector('.CollectionHero__categories-list'),
      $activeItem: component.querySelector('.CollectionHero__category.active')
    };
    this.mount();
  }

  (0, _createClass2["default"])(CollectionHero, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom;

      if (dom.$catmobile && dom.$catList && dom.$activeItem && dom.$catmobile.offsetWidth < dom.$catList.offsetWidth) {
        var rect = dom.$activeItem.getBoundingClientRect();
        dom.$catmobile.scrollLeft = rect.left - 50;
      }

      console.log('CollectionHero : mount', this);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom;
      console.log('CollectionHero : unmount', this);
    }
  }]);
  return CollectionHero;
}();

exports["default"] = CollectionHero;